var module = 'kiosk', name = 'kiosk/config/locales/fr_CA.json', content = {
  "kiosk": {
    "login_title": "Borne d'enregistrement",
    "home": {
      "title": "Borne d’enregistrement",
      "user_login": {
        "label": "Numéro d'assurance maladie",
        "placeholder": "AAAA 1111 1111",
        "submit": "Signaler mon arrivée"
      },
      "info": "La clinique vous offre la possibilité de vous enregistrer en libre-service, rapidement sans avoir à faire la file à la réception.<br/><br/><strong>Il suffit de vous identifier avec votre numéro d’assurance maladie.</strong>",
      "feedback_message": "<strong>À noter:</strong> Il suffit d’entrer votre numéro d’assurance maladie pour signaler l’arrivée de tous les comptes liés qui ont rendez-vous aujourd’hui."
    },
    "appointments": {
      "found_appointment_title": "Rendez-vous trouvé",
      "found_appointment_content": "Désirez-vous signaler votre arrivée pour ce rendez-vous ?",
      "found_multiple_appointments_title": "Plusieurs rendez-vous trouvés",
      "found_multiple_appointments_content": "Désirez-vous signaler l’arrivée pour tous ces rendez-vous ?",
      "confirm_appointment": "Confirmer",
      "confirmed_appointments_title": "Arrivée signalée",
      "confirmed_appointments_content": "Votre présence a été signalée avec succès à notre personnel. Veuillez vous diriger vers la salle d’attente.",
      "previously_confirmed_appointments_title": "Arrivée déjà signalée",
      "previously_confirmed_appointments_content": "Votre présence a été signalée avec succès à notre personnel. Veuillez vous diriger vers la salle d’attente indiquée.",
      "confirmed_appointment_note": "<strong>À noter</strong> pour un suivi adéquat de votre dossier, il est important de tenir vos informations de contact à jour. <strong>Vous pouvez actualiser vos renseignements sur le portail patient.</strong>",
      "waiting_room": "Salle d'attente {{waitingRoom}}"
    },
    "informations": {
      "title": "Valider vos renseignements",
      "content": "Est-ce que ces informations sont toujours exactes?",
      "address": "Adresse"
    },
    "error": {
      "generic": {
        "title": "Une erreur s’est produite",
        "content": "Il est impossible de confirmer votre rendez-vous. <strong>Veuillez vous présenter à la réception.</strong>"
      },
      "hin": {
        "title": "Carte d’assurance maladie expirée",
        "content": "Il est impossible de confirmer votre rendez-vous. <strong>Veuillez vous présenter à la réception.</strong>"
      },
      "no_appointments": {
        "title": "Aucun rendez-vous trouvé",
        "content": "Malheureusement, il n’y a aucun rendez-vous correspondant dans le système. <strong>Veuillez vous présenter à la réception.</strong>"
      },
      "invalid_informations": {
        "title": "Veuillez vous présenter à la réception pour la mise à jour de vos informations de contact et confirmer votre arrivée."
      }
    },
    "back_home": "Retour à l'accueil",
    "help": "Pour toutes questions ou assistance technique, veuillez vous présenter à la réception."
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./kiosk/config/locales/fr_CA.json
// module id = 1409
// module chunks = 0